import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PublicRoutes } from './routes';


function App() {
  return (
    <div className="App">
      <Router>
        <PublicRoutes />
      </Router>
      <ToastContainer />
    </div>
  );
}
export default App;
